/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics } from '@trello/atlassian-analytics';

import { isValidUrlForIframe } from 'app/scripts/lib/plugins/pluginValidators';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PluginView } from 'app/scripts/views/plugin/PluginView';

class PluginButtonView extends PluginView {
  static initClass() {
    this.prototype.events = {
      click(e) {
        const traceId = Analytics.getTraceId();
        try {
          e?.stopPropagation();
          if (typeof this.trackClick === 'function') {
            this.trackClick(this.pluginButton);
          }
          if (typeof this.trackTask === 'function') {
            this.trackTask(traceId, this.pluginButton);
          }
          if (this.pluginButton.callback != null) {
            // find the correct anchor for potential popup
            const el =
              e.target.closest('.button-link') ||
              e.target.closest('.board-header-btn') ||
              e.target.closest('a') ||
              e.target;
            if (this.isPopOverShowing(el)) {
              if (typeof this.taskSuccess === 'function') {
                this.taskSuccess(traceId, this.pluginButton);
              }
              return PopOver.hide();
            } else {
              return this.pluginButton
                .callback({
                  el,
                })
                .then(() => {
                  if (typeof this.taskSuccess === 'function') {
                    this.taskSuccess(traceId, this.pluginButton);
                  }
                })
                .catch((error) => {
                  if (typeof this.taskFailed === 'function') {
                    this.taskFailed(traceId, this.pluginButton, error);
                  }
                })
                .done();
            }
          } else {
            this.taskSuccess(traceId, this.pluginButton);
          }
        } catch (error) {
          if (typeof this.taskFailed === 'function') {
            this.taskFailed(traceId, this.pluginButton, error);
          }
        }
      },
    };
  }
  tagName() {
    if (this.options.pluginButton.url != null) {
      return 'a';
    } else {
      return 'span';
    }
  }

  attributes() {
    const { url, target } = this.options.pluginButton;
    if (url && isValidUrlForIframe(url)) {
      return {
        href: url,
        target: target ?? url,
        rel: 'noreferrer nofollow noopener',
      };
    }
  }

  initialize({ pluginButton }) {
    this.pluginButton = pluginButton;
    return this.retain(this.pluginButton);
  }

  template() {
    throw Error('no template specified');
  }

  isPopOverShowing(el) {
    return PopOver.contains(el) || PopOver.toggledBy(el);
  }

  renderOnce() {
    this.$el.html(this.template(this.pluginButton));
    return this;
  }
}
PluginButtonView.initClass();
export { PluginButtonView };
